import { useUpdateAccessKeyStatus } from '@api/accessKeys';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';
import { IRowActionDialogProps } from 'types/common';
import AccessKeyStatusDialog from '../Helpers/AccessKeyStatusDialog';

const StatusDialog: React.FC<IRowActionDialogProps> = (props) => {
	const accessKeysMutation = useUpdateAccessKeyStatus();
	return (
		<AccessKeyStatusDialog
			{...props}
			mutation={accessKeysMutation}
			accessKeyType={AccessKeyType.access}
		/>
	);
};

export default StatusDialog;
